import { useLazyQuery } from "@apollo/client";
import { useEffect, useMemo } from "react";
import {
  useUserDispatch,
  useUserState,
  setUserBuildings,
} from "../context/UserContext";
import { QUERIES } from "../graphql";

export function useLoggedUserInfo() {
  const { userBuilding, userRole, userBuildings } = useUserState();
  const dispatch = useUserDispatch();

  const [invokeLoadBuildings] = useLazyQuery(QUERIES.BUILDINGS("light"), {
    onCompleted: ({ buildings }) => {
      setUserBuildings(dispatch, [...buildings]);
    },
  });

  const isAdminUser = useMemo(() => {
    return userRole === "system_admin";
  }, [userRole]);

  const isConciergeUser = useMemo(() => {
    return userRole === "concierge";
  }, [userRole]);

  const isServiceProviderUser = useMemo(() => {
    return userRole === "service_provider";
  }, [userRole]);

  const isRegularUser = useMemo(() => {
    return userRole === "user";
  }, [userRole]);

  const isBuildingManagerUser = useMemo(() => {
    return userRole === "building_manager";
  }, [userRole]);

  useEffect(() => {
    if (isAdminUser) {
      invokeLoadBuildings();
    }
  }, [invokeLoadBuildings, isAdminUser]);

  return {
    userBuilding,
    userBuildings,
    isAdminUser,
    isConciergeUser,
    isServiceProviderUser,
    isRegularUser,
    isBuildingManagerUser,
  };
}
